// extracted by mini-css-extract-plugin
module.exports = {"title":"CarInfo_title__MEaRT","car-info":"CarInfo_car-info___cqKf"};